import type { StoneSpecification } from '@/features/pdp/domain/models/ProductDetail';
import { formatStoneSpecSize } from '@/features/pdp/utils/productDetailStones';

interface PdpDesktopStoneSpecTableProps {
  specs: StoneSpecification[];
}

interface SpecRow {
  label: string;
  values: Array<string | number | null>;
}

function buildSpecRows(specs: StoneSpecification[]): SpecRow[] {
  const rows: SpecRow[] = [
    { label: 'Count', values: specs.map((spec) => spec.count) },
    { label: 'Shape', values: specs.map((spec) => spec.shape) },
    { label: 'Size', values: specs.map((spec) => formatStoneSpecSize(spec)) },
    { label: 'Setting Type', values: specs.map((spec) => spec.settingType) },
  ];

  return rows.filter((row) => row.values.some((value) => value != null && value !== ''));
}

export function PdpDesktopStoneSpecTable({ specs }: PdpDesktopStoneSpecTableProps) {
  if (specs.length === 0) return null;

  const rows = buildSpecRows(specs);
  if (rows.length === 0) return null;

  return (
    <div className="max-w-full min-w-0 overflow-x-auto overscroll-x-contain [scrollbar-width:thin]">
      <table className="w-max min-w-full border-collapse text-xs text-[#5b7da3]">
        <tbody>
          {rows.map((row) => (
            <tr key={row.label} className="border-t border-[#eee]">
              <th
                scope="row"
                className="sticky left-0 z-[1] w-[7.5rem] min-w-[7.5rem] bg-white py-2.5 pl-4 pr-2 text-left font-normal shadow-[4px_0_8px_-6px_rgba(0,0,0,0.18)]"
              >
                {row.label}
              </th>
              {row.values.map((value, index) => (
                <td
                  key={`${row.label}-${index}`}
                  className={`min-w-[4.5rem] whitespace-nowrap py-2.5 pl-2 text-right ${
                    index === row.values.length - 1 ? 'pr-4' : 'pr-2'
                  }`}
                >
                  {value ?? ''}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
